import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/atoms/Button/Button';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import Box from 'components/atoms/Box/Box';

export default function ButtonsGroup(props) {
  const [selectedValue, setSelectedValue] = useState(0);

  const { label1, label2 } = props;

  const onButtonClick = (value) => {
    if (props.onButtonClick) {
      props.onButtonClick(value);
    }
  };
  return (
    <Box mb={2}>
      <GridContainer spacing={1}>
        <GridItem xs={label2 ? 6 : 12}>
          <Button
            fullWidth
            onClick={() => {
              setSelectedValue(0);
              onButtonClick(0);
            }}
            variant={selectedValue !== 0 ? 'outlined' : 'contained'}
          >
            {label1}
          </Button>
        </GridItem>
        {label2 && (
          <GridItem xs={6}>
            <Button
              fullWidth
              onClick={() => {
                setSelectedValue(1);
                onButtonClick(1);
              }}
              variant={selectedValue !== 1 ? 'outlined' : 'contained'}
            >
              {label2}
            </Button>
          </GridItem>
        )}
      </GridContainer>
    </Box>
  );
}

ButtonsGroup.propTypes = {
  /**
   * Label of the first button
   */
  label1: PropTypes.string,
  /**
   * Label of the second button
   */
  label2: PropTypes.string,
  /**
   * Callback function that is called when one of the buttons is clicked. It returns value of selected button.
   */
  onButtonClick: PropTypes.func.isRequired,
};
